module.exports = __webpack_public_path__ + "static/imgs/lyrical.cd12360.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/lyrical.jpg
// module id = i3cX
// module chunks = 1